import { useTranslation } from "react-i18next";
import i18n from "src/i18n/config";

import { InputAdornment } from "@mui/material";
import { NumberField } from "@shared/form/NumberField";

export const validateRollout = (value: number): string | undefined => {
    if (value < 0 || value > 100) {
        return i18n.t("modals:buildConfig.input.rollout.validation.range");
    }
    return undefined;
};

type RolloutFieldProps = {
    name: string;
    required?: boolean;
    fullWidth?: boolean;
};

export const RolloutField = ({ name, required = true, fullWidth = true }: RolloutFieldProps) => {
    const { t } = useTranslation(["modals"]);

    return (
        <NumberField
            name={name}
            label={t("modals:buildConfig.input.rollout.caption")}
            fullWidth={fullWidth}
            required={required}
            slotProps={{
                input: {
                    startAdornment: <InputAdornment position="start">%</InputAdornment>,
                },
            }}
        />
    );
};
